import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import TextEditor from "../components/rich-text/TextEditor/TextEditor";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";
import { CACHE_KEY } from "../constant/cache-key";

export default function DandWBody({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [images, setImages] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);
  const hiddenFileInput = useRef();

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  // Get Data from backend
  useEffect(() => {
    let docs = langs.map((item) => ({
      body: "",
      language: item.attributes.language,
    }));
    setData(docs);

    async function getData() {
      await fetch(`${API}/dw`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.body || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find(
              (apiItem) => apiItem.language === localItem.language
            );

            if (apiItem) {
              return {
                ...localItem,
                body: apiItem.body || localItem.body,
              };
            } else {
              return localItem;
            }
          });
        });

        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const submitData = () => {
    fetch(`${API}/dw`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { body: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  return (
    <TabContext value={value}>
      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>
          D&W Body Settings
        </h3>

        <Box mt={2}>
          <ClearCacheButton
            keys={[
              CACHE_KEY.depositAndWithdrawal,
              CACHE_KEY.startupConfigs
            ]} />
        </Box>

        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs"
        >
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={
                      SERVER_DOMAIN + item.attributes.icon.data.attributes.url
                    }
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                  <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 20,
                    }}
                  >
                    <div>
                      <p style={{ fontSize: 15, marginBottom: 8 }}>Body Text</p>

                      <div style={{ margin: "10px 0" }}>
                        <TextEditor
                          value={data[index]?.body || ""}
                          onChange={(v) => {
                            setData([
                              ...data.map((item, idx) => {
                                if (idx === index) {
                                  return {
                                    ...item,
                                    body: v,
                                  };
                                } else {
                                  return item;
                                }
                              }),
                            ]);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {user.perms[14].edit && (
                    <div
                      className="submitBTN"
                      onClick={() => submitData(item, index)}
                    >
                      Save Changes
                    </div>
                  )}
                </TabPanel>
              );
            })}
          </>
        )}
      </Box>
    </TabContext>
  );
}
